export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderNotification@2x.png";